"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbitalReflectors = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class OrbitalReflectors extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.ORBITAL_REFLECTORS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.SPACE],
            cost: 26,
            tr: { venus: 2 },
            metadata: {
                cardNumber: '242',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.venus(2).br;
                    b.production((pb) => {
                        pb.heat(2);
                    });
                }),
                description: 'Raise Venus 2 steps. Increase your heat production 2 steps.',
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.game.increaseVenusScaleLevel(player, 2);
        player.addProduction(Resources_1.Resources.HEAT, 2);
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, venusIncrease: 2, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.OrbitalReflectors = OrbitalReflectors;
//# sourceMappingURL=OrbitalReflectors.js.map